import React from "react";
import ModelPage from "../pages/api-reference/Model.mdx";
import SessionModelPage from "../pages/api-reference/SessionModel.mdx";

const ModelPagePicker = (props: {
  environment?: { sessionModelApiIdentifier: string | null };
  params?: { model: string };
  currentApp: { model?: { apiIdentifier: string } };
}) => {
  if (
    (props.params && props.environment?.sessionModelApiIdentifier == props.params?.model) ||
    props.currentApp.model?.apiIdentifier == props.environment?.sessionModelApiIdentifier
  ) {
    return <SessionModelPage {...props} />;
  } else {
    return <ModelPage {...props} />;
  }
};

export default ModelPagePicker;
